/**
 * The steps available when progressing through a ConfigMigration import.
 */
export enum MigrationStep {
  UPLOAD = 'UPLOAD',
  SCHEMAS = 'SCHEMAS',
  TEMPLATES = 'TEMPLATES',
  PROCESS_TASK_SCHEMAS = 'PROCESS_TASK_SCHEMAS',
  STUDIES = 'STUDIES',
  REVIEW = 'REVIEW',
}

export const INITIAL_STEP = MigrationStep.UPLOAD;

/** All Migration steps that can be planned. This should generally be all steps besides Upload and Review. */
export type PlannableMigrationStep =
  | MigrationStep.SCHEMAS
  | MigrationStep.TEMPLATES
  | MigrationStep.PROCESS_TASK_SCHEMAS
  | MigrationStep.STUDIES;

/** The string to display when there are no items to be planned on the current step. */
export const PLANNABLE_STEPS_TO_EMPTY_DISPLAY_TEXT: {[key in PlannableMigrationStep]: string} = {
  [MigrationStep.SCHEMAS]: 'No schema changes included in this migration.',
  [MigrationStep.TEMPLATES]: 'No template changes included in this migration.',
  [MigrationStep.PROCESS_TASK_SCHEMAS]: 'No workflow item changes included in this migration.',
  [MigrationStep.STUDIES]: 'No study schema changes included in this migration.',
};
